module.exports = __webpack_public_path__ + "static/img/login-bg.08da97bd.jpg";